/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DivideAndConquerCursorData
 *
 */
// create custom validators for the regexes
export interface DivideAndConquerCursorData {
    /**
     *
     * #type Array<string>
     * #memberof DivideAndConquerCursorData
        
        
         */
    cursors: Array<string>;
}
/**
 * Check if a given object implements the DivideAndConquerCursorData interface.
 */
export function instanceOfDivideAndConquerCursorData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cursors" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DivideAndConquerCursorDataTypiaAssertEquals = (input: any) => {
    return ((input: any): DivideAndConquerCursorData => {
        const __is = (input: any, _exceptionable: boolean = true): input is DivideAndConquerCursorData => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => Array.isArray(input.cursors) && input.cursors.every((elem: any, _index1: number) => "string" === typeof elem) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cursors"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DivideAndConquerCursorData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ((Array.isArray(input.cursors) || $guard(_exceptionable, {
                    path: _path + ".cursors",
                    expected: "Array<string>",
                    value: input.cursors
                })) && input.cursors.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".cursors[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".cursors",
                    expected: "Array<string>",
                    value: input.cursors
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cursors"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DivideAndConquerCursorData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DivideAndConquerCursorData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DivideAndConquerCursorDataTypiaAssertStringify = (input: DivideAndConquerCursorData): string => {
    return ((input: any): string => { const assert = (input: any): DivideAndConquerCursorData => {
        const __is = (input: any): input is DivideAndConquerCursorData => {
            const $io0 = (input: any): boolean => Array.isArray(input.cursors) && input.cursors.every((elem: any) => "string" === typeof elem);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DivideAndConquerCursorData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (Array.isArray(input.cursors) || $guard(_exceptionable, {
                    path: _path + ".cursors",
                    expected: "Array<string>",
                    value: input.cursors
                })) && input.cursors.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".cursors[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".cursors",
                    expected: "Array<string>",
                    value: input.cursors
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DivideAndConquerCursorData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DivideAndConquerCursorData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DivideAndConquerCursorData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $so0 = (input: any): any => `{"cursors":${`[${input.cursors.map((elem: any) => $string(elem)).join(",")}]`}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DivideAndConquerCursorDataValidatorShape = {
    'cursors': yup.array().of(yup.string()).defined(),
};
export const DivideAndConquerCursorDataValidator = yup.object().shape(DivideAndConquerCursorDataValidatorShape);
export const DivideAndConquerCursorDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'cursors': {
        type: 'array',
        items: {
            type: 'string'
        } as unknown as fastJSON.Schema,
    } as unknown as fastJSON.ArraySchema,
};
export const DivideAndConquerCursorDataStringifyShape: ObjectSchema = {
    title: 'DivideAndConquerCursorData Stringifier',
    type: 'object',
    properties: {
        ...DivideAndConquerCursorDataStringifyShapeProperties
    },
    required: [
        'cursors',
    ],
};
export const DivideAndConquerCursorDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DivideAndConquerCursorDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DivideAndConquerCursorDataStringify: (data: DivideAndConquerCursorData) => string = DivideAndConquerCursorDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DivideAndConquerCursorDataFromJSON(json: any): DivideAndConquerCursorData {
    return DivideAndConquerCursorDataFromJSONTyped(json, false);
}
export function DivideAndConquerCursorDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DivideAndConquerCursorData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'cursors': json['cursors'],
    };
}
export function DivideAndConquerCursorDataToJSON(value?: DivideAndConquerCursorData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cursors': value.cursors,
    };
}
